import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter, InitializeFilterDropdown } from "../../../../shared/scripts/filtering";
import { getData } from "./site.utilities";

export class CTMSSiteStaffSection implements IFilter {

    items: any[];
    itemsTable: any;
    tableSelector = '#staffTable';
    searchSelector = '#staff-search';
    clearSelector = '#staff-search-clear';

    url: string;

    constructor(handlerUrl: string){
        this.url = handlerUrl;

        this.initialize();
    }

    initialize() {
        this.itemsTable = $(this.tableSelector).DataTable({
            "dom": 'lrtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '200px',
            scrollCollapse: true,
            orderCellsTop: true,
            columns: [
                { data:'Name', title: 'Name', className: '' },
                { data:'RoleName', title: 'Role', className: '' },
            ]
        });

        InitializeFilterDropdown('#staff-role', [], this);

        $(this.searchSelector).on('input', (evt) => {
            $(this.tableSelector).DataTable().search(String($(evt.target).val() ?? '')).draw();
        });
        $(this.clearSelector).on('click', (evt) => {
            $(this.searchSelector).val('');
            $(this.tableSelector).DataTable().search('').draw();
        });

    }

    async loadData() {
        $('#staffSectionLoading').removeClass('d-none');

        this.items = await getData(this.url);

        this.itemsTable.clear();
        this.itemsTable.rows.add(this.items).draw();

        const roleValues = Unique(this.items.map(c => c.RoleName).flat(), true).sort();
        $('#staff-role').empty();
        $('#staff-role').append(roleValues.map(e => new Option(e, e, false, true)));
        $('#staff-role').selectpicker("refresh");

        $('#staffSectionLoading').addClass('d-none');
    }

    triggerFilter() {
        const study = $('#staff-role').val() as [any];

        const filteredItems = this.items.filter((c) => {
            return study.some(s => c.RoleName.includes(s));
        });

        this.itemsTable.clear();
        this.itemsTable.rows.add(filteredItems).draw();
    }
}